/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { Mousetrap } from '../Mousetrap';

interface ActionButtonProps {
    type?: string;
    children?: React.ReactNode;
    highlighted?: boolean;
    index?: number;
    ghostmode?: boolean;
}

const ActionButton: FunctionComponent<ActionButtonProps> = ({
    type,
    children,
    highlighted,
    index,
    ghostmode,
}) => {
    const displayText = type === 'options' ? 'Options' : 'See more info';

    // eslint-disable-next-line no-nested-ternary
    const highlightClass = highlighted ? (ghostmode ? ' ghost-mode' : ' highlighted') : '';

    return (
        <Mousetrap
            className={`uikit btn primary-text-style text-size-large${highlightClass}`}
            key={`action_button_items_${index}`}
            value={`action_button_items_${index}`}
        >
            {children || displayText}
        </Mousetrap>
    );
};

export default ActionButton;
